export default {
  defaults: {
    loggedCustomer: null,
    budtenderNeeded: false
  },
  resolvers: {},
  typeDefs: `
    type Customer {
      id
      phoneNumber
      pointsBalance
      interestIds
      usageTypeIds
    }

    type LoggedCustomer {
      authToken: String!
      pointsEarned: Int
      newCustomer: Boolean
      newLocation: Boolean
      hashedPin: Int
      customer: Customer
      skipInterestsStep: Boolean
    }

    type Query {
      loggedCustomer: LoggedCustomer
      budtenderNeeded: Boolean
    }
  `
};



// WEBPACK FOOTER //
// ./src/api/local.ts